import { ProtectedRoute } from '../components/ProtectedRoute';
import UserDashboard from './UserDashboard';

export default function ProtectedUserDashboard() {
  return (
    <ProtectedRoute>
      <UserDashboard />
    </ProtectedRoute>
  );
}
